import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Sports win commission — owner-only. The server refuses staff/executive
// sessions via requireOwnerOr(key) (an owner executive passes only with that
// key); the sidebar and OWNER_PERMISSIONS hide the screen
// on the client.
// Plan: docs/plans/2026-09-12-commission-market-league-split.md
const commissionConfigService = {
  // {
  //   markets: [{ key, label, group, hint }],
  //   default_league_key: 'default', max_percent, default_percent,
  //   sports: [{ sport_id, name, enabled, active_count, leagues: [
  //     { key, label, is_default, active_count,
  //       rules: { matchodds: { state: 'on'|'off'|'inherit', percent, inherited } } }
  //   ]}]
  // }
  getSportsCommission: async () => {
    const response = await api.get(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS)
    return response.data
  },
  // { sport_id, league_key, market_key, enabled, percent }
  saveSportsCommission: async (payload) => {
    const response = await api.post(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS, payload)
    return response.data
  },
  // { items: [{ sport_id, league_key, market_key, enabled, percent }, …] }
  // One request for every dirty cell — the grid gained a league dimension, so
  // saving cell by cell meant dozens of round trips.
  saveSportsCommissionBulk: async (items) => {
    const response = await api.post(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS_BULK, { items })
    return response.data
  },
  // { sport_id, league_key, market_key } — drops a league override so the cell
  // inherits the sport's default row again. Never valid on the default league.
  resetSportsCommission: async (payload) => {
    const response = await api.delete(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS, { data: payload })
    return response.data
  },
  // Per market family inside "Other Main Markets" (Next Goal, Over/Under…).
  // Plan: docs/plans/2026-10-21-commission-per-market-family.md
  // { fallback: { enabled, percent }, max_percent, default_percent,
  //   families: [{ family, label, samples: [name…], bets, rule: { enabled, percent } | null }] }
  getMarketFamilies: async (sportId) => {
    const response = await api.get(API_ENDPOINTS.COMMISSION_CONFIG.SPORT_MARKETS(sportId))
    return response.data
  },
  // items: [{ market, label, enabled, percent }] — market = family key or any raw name
  saveMarketFamilies: async (sportId, items) => {
    const response = await api.post(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS_MARKETS, { sport_id: sportId, items })
    return response.data
  },
  // Drops the row so the family follows "Other Main Markets" again.
  resetMarketFamily: async (sportId, market) => {
    const response = await api.delete(API_ENDPOINTS.COMMISSION_CONFIG.SPORTS_MARKETS, { data: { sport_id: sportId, market } })
    return response.data
  },
}

export default commissionConfigService
